import React, { useCallback, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useUser } from "../../redux/services/authSlice";
import { getBalance } from "../../redux/services/balanceSlice";
import Table from "../../common/Table";
import moment from "moment-timezone";
import { convertUtcToIst } from "../../common/TimeUtils";
import { exportToTablePDF } from "../../common/PdfFormat";

const Withdrawal = () => {
  const dispatch = useDispatch();
  const { user } = useUser();
  const getBalanceData = useSelector((state) => state?.balance?.balanceData);
  const getAllBalance = useCallback(async () => {
    try {
      await dispatch(
        getBalance({ userFilter: user._id, typeFilter: "withdraw" })
      );
    } catch (error) {}
  }, [dispatch, user]);

  useEffect(() => {
    getAllBalance();
  }, [getAllBalance]);
  const columns = [
    {
      header: "S/N",
      key: "index",
      render: (_, __, index) => index + 1,
    },
    { header: "Name", key: "name" },
    {
      header: "Date",
      key: "updatedAt",
      render: (_, row) =>
        row.updatedAt
          ? moment(convertUtcToIst(row.updatedAt)).format("DD-MM-YYYY")
          : "-",
    },
    { header: "Type", key: "type" },
    { header: "Amount", key: "amount" },
  ];
  const exportToPDF = () => {
    const headersConfig = [
      {
        label: "S/N",
        key: "index",
        render: (_, __, index) => index + 1,
      },
      { label: "Name", key: "name" },
      {
        label: "Date",
        key: "updatedAt",
        render: (_, row) =>
          row.updatedAt
            ? moment(convertUtcToIst(row.updatedAt)).format("DD-MM-YYYY")
            : "-",
      },
      { label: "Type", key: "type" },
      { label: "Amount", key: "amount" },
    ];
    const data = getBalanceData?.balance_data || [];
    exportToTablePDF({
      tableName: "Withdrawal Data",
      data,
      headersConfig,
      pdfName: "withdrawal_data.pdf",
    });
  };
  return (
    <div>
      <Table
        title="Withdrawal"
        columns={columns}
        data={getBalanceData?.balance_data}
        exportButton={true}
        onExport={exportToPDF}
      />
    </div>
  );
};

export default Withdrawal;
